import { render, staticRenderFns } from "./TableAddBooking.vue?vue&type=template&id=2481ea74&scoped=true"
import script from "./TableAddBooking.vue?vue&type=script&lang=js"
export * from "./TableAddBooking.vue?vue&type=script&lang=js"
import style0 from "./TableAddBooking.vue?vue&type=style&index=0&id=2481ea74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2481ea74",
  null
  
)

export default component.exports